import { render, staticRenderFns } from "./SandList.vue?vue&type=template&id=0fa0a270&scoped=true"
import script from "./SandList.vue?vue&type=script&lang=js"
export * from "./SandList.vue?vue&type=script&lang=js"
import style0 from "./SandList.vue?vue&type=style&index=0&id=0fa0a270&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa0a270",
  null
  
)

export default component.exports